export const borderWidthScale: Record<string, string> = {
  "0": "0px", 
  DEFAULT: "1px", 
  "2": "2px", 
  "4": "4px", 
  "8": "8px",
};

export const borderRadiusScale: Record<string, string> = {
  none: "0px", 
  sm: "2px", 
  DEFAULT: "4px", 
  md: "6px", 
  lg: "8px",
  xl: "12px", 
  "2xl": "16px", 
  "3xl": "24px", 
  full: "9999px",
};

export const borderStyleValues: Record<string, string> = {
  solid: "solid", 
  dashed: "dashed", 
  dotted: "dotted",
  double: "double", 
  hidden: "hidden", 
  none: "none",
};

export const outlineWidthScale: Record<string, string> = {
  "0": "0px", 
  "1": "1px", 
  "2": "2px", 
  "4": "4px", 
  "8": "8px",
};

export const outlineOffsetScale: Record<string, string> = {
  "0": "0px", 
  "1": "1px", 
  "2": "2px", 
  "4": "4px", 
  "8": "8px",
};
